import * as tslib_1 from "tslib";
import { Avatar, Icon, Tag, Tooltip } from "@h3/antd-vue";
import { Component } from "vue-property-decorator";
import { StaffSelectorControl } from "../controls/staff-selector-control";
import StaffSelector from "./staff-selector.vue";
import getDownloadUrlNew from '../../../../../../common/src/utils/getDownloadUrlNew';
let FormStaffSelector = class FormStaffSelector extends StaffSelectorControl {
    constructor() {
        super(...arguments);
        this.showToggle = false;
        this.collapsed = true;
    }
    toggle() {
        this.collapsed = !this.collapsed;
    }
    scroll() {
        const el = this.$el.querySelector('.form-staff');
        if (el) {
            this.showToggle = el.scrollHeight > el.offsetHeight + 3;
            if (el.offsetHeight === 0) {
                clearTimeout(this.taskRef);
                this.taskRef = setTimeout(() => {
                    this.scroll();
                }, 1000);
            }
        }
    }
    onValueChange(value) {
        const val = value && value.length > 0 ? value : null;
        this.setValue(val);
    }
    mounted() {
        // 选人控件需要从根节点开始显示
        this.staffSelectorOpts.isDisplayRoot = true;
        if (this.readonly) {
            this.$nextTick(() => {
                this.scroll();
            });
        }
    }
    get apiHost() {
        return window.config.apiHost;
    }
    get token() {
        return window.localStorage.getItem('token');
    }
    getDownloadUrlNew(img) {
        if (img && img.includes('http')) {
            return img;
        }
        else if (img) {
            return getDownloadUrlNew.getImageUrl(img);
        }
        else {
            return img;
        }
    }
    // 是否为外部用户
    get isExternal() {
        if (window.isExternal) {
            return true;
        }
        return false;
    }
};
FormStaffSelector = tslib_1.__decorate([
    Component({
        name: "form-staff-selector",
        components: {
            ATag: Tag,
            AIcon: Icon,
            AAvatar: Avatar,
            StaffSelector,
            ATooltip: Tooltip
        }
    })
], FormStaffSelector);
export default FormStaffSelector;
